import Head from 'src/components/head';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const Seo = (props) => {
  const { title } = props;
  const { t } = useTranslation();
  const fullTitle = title ? t(title) : 'TC439';

  return (
    <Head>
      <title>{fullTitle}</title>
    </Head>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
};
